import { addMinutes, addHours, addDays, isBefore } from 'date-fns'
import httpClient from '@/libs/http-client'

let cacheSet = {}

function getObjectKey (obj) {
  const key = Object.entries(obj).map(([key, value]) => {
    return `${key}=${JSON.stringify(value)}`
  }).join('&')
  return key
}

function getCacheKey (config) {
  const method = config.method || 'get'
  const cacheKeys = [method, config.url]

  if (config.params) {
    cacheKeys.push(getObjectKey(config.params))
  }
  if (config.data) {
    cacheKeys.push(getObjectKey(config.data))
  }
  const key = cacheKeys.join('|')
  return key
}

function getTtlDate (ttl) {
  const ttlRegex = /^\d+[mMhHdD]$/

  if (!ttlRegex.test(ttl)) {
    console.error(`invalid ttl: ${ttl}`)
    return null
  }
  const now = new Date()
  const value = parseInt(ttl, 10)
  const unit = ttl.charAt(ttl.length - 1).toLowerCase()

  switch (unit) {
    case 'm':
      return addMinutes(now, -value)
    case 'h':
      return addHours(now, -value)
    case 'd':
      return addDays(now, -value)
    default:
      return null
  }
}

function setCache (key, data) {
  cacheSet[key] = {
    data,
    date: new Date()
  }
}

function getCache (key, ttl) {
  const cache = cacheSet[key]
  const ttlDate = getTtlDate(ttl)

  if (cache) {
    if (isBefore(cache.date, ttlDate)) {
      delete cacheSet[key]
    } else {
      return cache.data
    }
  }
  return null
}

export function clearAllApiCache () {
  cacheSet = {}
}

export function request (config, force = false, ttl = '3m') {
  const isApiRequest = config.url.charAt(0) === '/'

  if (!isApiRequest) {
    return httpClient(config)
  }

  const key = getCacheKey(config)

  if (!force && ttl) {
    const cache = getCache(key, ttl)

    if (cache) {
      cache.cache = true
      return Promise.resolve(cache)
    }
  }

  return httpClient(config).then(response => {
    const data = response.data.result
    setCache(key, Array.isArray(response.data.result) ? [ ...response.data.result ] : { ...response.data.result })
    if (data && typeof data === 'object') {
      data['cache'] = false
    }
    return data
  })
}
